var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-nav",class:`header-nav--${_vm.view}`},[_c('router-link',{staticClass:"header-nav__link",attrs:{"to":{
      name: 'content',
      params: { alias: 'contacts', town: _vm.town },
    }}},[_vm._v(" Контакты ")]),_c('router-link',{staticClass:"header-nav__link",attrs:{"to":{ name: 'content', params: { alias: 'sposoby-oplaty-zakazov' } }}},[_vm._v(" Оплата ")]),_c('router-link',{staticClass:"header-nav__link",attrs:{"to":{ name: 'content', params: { alias: 'dostavka-avtozapchastei' } }}},[_vm._v(" Доставка ")]),_c('router-link',{staticClass:"header-nav__link",attrs:{"to":{
      name: 'content',
      params: { alias: 'garantiya-i-usloviya-vozvrata-detalei' },
    }}},[_vm._v(" Возврат ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }